window.hoculus = window.hoculus || {};
if (console && console.log) {
	console.log(
		"Coded by %cHoculus srl %con %cShopify %c- %c" +
			Shopify.theme.name +
			" %c -> https://www.hoculus.com",
		"color: red; font-weight: bold",
		"color: unset",
		"color: green",
		"color: unset",
		"color: blue",
		"color: unset; font-weight: bold"
	);
}

hoculus.utils = {
	getScript: function (source, callback) {
		hoculus.loadedScripts = hoculus.loadedScripts || [];
		if (hoculus.loadedScripts.includes(source)) {
			setTimeout(callback, 0);
		} else {
			var script = document.createElement("script");
			var prior = document.getElementsByTagName("script")[0];
			script.defer = 1;

			script.onload = script.onreadystatechange = function (_, isAbort) {
				if (
					isAbort ||
					!script.readyState ||
					/loaded|complete/.test(script.readyState)
				) {
					script.onload = script.onreadystatechange = null;
					script = undefined;

					if (!isAbort && callback) setTimeout(callback, 0);
				}
			};
			script.src = source;
			prior.parentNode.insertBefore(script, prior);
		}
	},
	getScriptAsync: async function (source) {
		hoculus.loadedScripts = hoculus.loadedScripts || [];
		return await new Promise(function (resolve, reject) {
			if (hoculus.loadedScripts.includes(source)) {
				resolve(true);
			} else {
				var script = document.createElement("script");
				var prior = document.getElementsByTagName("script")[0];
				script.defer = 1;

				script.onload = script.onreadystatechange = function (_, isAbort) {
					if (
						isAbort ||
						!script.readyState ||
						/loaded|complete/.test(script.readyState)
					) {
						script.onload = script.onreadystatechange = null;
						script = undefined;

						if (!isAbort) setTimeout(resolve(true), 0);
					}
				};

				script.src = source;
				prior.parentNode.insertBefore(script, prior);
			}
		});
	},
	onInteraction: function () {
		hoculus.interacted = hoculus.interacted || false;
		if (hoculus.interacted) {
			hoculus.utils.getScriptAsync(hoculus.assets.js.backToTop);
			hoculus.interacted = true;
		}
	},
	waitJquery: function (callback) {
		window.$
			? callback
			: setTimeout(function () {
					hoculus.utils.waitJquery(callback);
			  }, 50);
	},
	addToCart: function (items) {
		return new Promise(function (resolve, reject) {
			var postData = JSON.stringify({items:items})
			fetch('/cart/add.js', {
				method: 'POST',
				headers: {
				  'Content-Type': 'application/json'
				},
				body: postData
			  }).then(response => {
				return response.json();
			  }).then(data => {
				console.log(data)
				if(data.status == 422) resolve(false)
				resolve(data);
			  }).catch((error) => {
				console.error('Error:', error);
				reject(error)
			  });
		});
	},
	addDiscount: function (discount) {
		return new Promise(function (resolve, reject) {
			fetch("/discount/" + discount).then((data) => {
				resolve(data);
			});
		});
	},
	openCart: function() {
		document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
			bubbles: true
		}));
		window.dispatchEvent(new CustomEvent('hoculus:cart:open'));
	},
	onLoad: async function () {
		console.log("...");
		hoculus.utils.getScriptAsync(hoculus.assets.js.hoculusOptionSelection).then((resp) => {
			hoculus.selectCustomPcard();
			hoculus.selectBundle();
		});
		
		document.querySelectorAll('a[href="#"]').forEach((el) => {
			el.addEventListener("click", function (e) {
				e.preventDefault ? e.preventDefault() : (e.returnValue = false);
			});
		});

		hoculus.updateShippingBar();
		hoculus.stickyBuy();
		
		console.log("onLoad finish");
	},
	domready: function (callback) {
		if (document.readyState == "complete") callback();
		else document.addEventListener("DOMContentLoaded", callback);
	},
};

hoculus.updateShippingBar = function() {
	var func = this;
	this.setValues = function(data_success, success) {
		let width_perc = success  * 100 / parseFloat(hoculus.theme.shipping_goal_amount)
		data_success.style = `width: ${width_perc}%`
		if (width_perc > 0) {
			data_success.style.left = 0;
		} else {
			data_success.style.left = "1.5rem";
		}
		data_success.innerText =  "€" + parseFloat(success).toFixed(2).replace(".",",").replace(/\B(?=(\d{3})+(?!\d))/g, '.');
	}

	this.updateBars = function (bars,cart) {
		bars.forEach(b=> {
			const success = b.querySelector(".shipping-progress");
			const heading = b.querySelector(".progress-heading")

			let cur_price = parseFloat(cart.total_price / 100);
			let progress_value = cur_price;

			if(cur_price > parseFloat(hoculus.theme.shipping_goal_amount)) {
				shipping_text = hoculus.theme.shipping_text_success
			} else {
				shipping_text = hoculus.theme.shipping_text_default.replace("[mancante]", "€" + (parseFloat(hoculus.theme.shipping_goal_amount) - progress_value).toFixed(2).replace(".",",").replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
			}
			heading.innerText = shipping_text;
			func.setValues(success, progress_value)
		})
	}

	this.getCartPromise = async function (bars) {
		var response = await fetch('/cart.js');
		var cart = await response.json();
		func.updateBars(bars,cart);
	}

	this.observeDrawer = function(bars) {
		const attrObserver = new MutationObserver((mutations) => {
			mutations.forEach(mu => {
			  if (mu.attributeName !== "class") return;
				  func.callback(bars);
			});
		  });
		  
		const ELS_test = document.querySelectorAll(".LoadingBar");
		ELS_test.forEach (el => attrObserver.observe(el, {attributes: true}));
	}
	this.callback = function(bars) {
		bars.length > 0 ? func.getCartPromise(bars) : 0
	}

	this.init = function () {
		const all_shipping_bars = document.querySelectorAll('[id^="hoculus-shipping"]')

		document.querySelectorAll("[data-action='add-to-cart']").forEach(atc => {
			atc.addEventListener("click", function() {
				func.callback(all_shipping_bars)
			})
		});
		this.observeDrawer(all_shipping_bars)
	}

	this.init2 = function() {
		let listeners = ['hoculus:cart:drawer:refresh','hoculus:cart:quantityUpdate'];
		listeners.forEach( e => {
			document.addEventListener(e, function() {
				const all_shipping_bars = document.querySelectorAll('[id^="hoculus-shipping"]');
				func.getCartPromise(all_shipping_bars);
			})
		})
	}

	func.init2()
}
hoculus.selectCustomPcard = function () {
	var func = this;
	// this.openSlideCart = function () {
	// 	$('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]')[0].click();
	// };

	this.shopifyPostCart = async function (form) {
		let formData = {
			'items': [{
			 'id': parseInt(form.querySelector("input[type='hidden'][name='id']").value),
			 'quantity': 1,
			 'properties':{
			 }
			 }]
		};
		
		let properties = form.querySelectorAll("input[type='hidden'][name^='properties']")
		properties.forEach(p=> {
			formData.items[0].properties[p.getAttribute("name").replace("properties[","").replace("]","")] = p.getAttribute("value")
		})

		await fetch(window.Shopify.routes.root + 'cart/add.js', {
			 method: 'POST',
			 headers: {
			   'Content-Type': 'application/json'
			 },
			 body: JSON.stringify(formData)
		})
		.then(res => {
			hoculus.utils.openCart();
			if(location.href.includes("cart")) {
				let close = form.parentNode.querySelector("span.close")
				close.parentElement.style.display = "none"
			}
		})
		.catch((error) => {
			 console.error('Error:', error);
		});
	}

	this.loadSelects = (selects) => {
		selects.forEach(function (e, i) {
			e.classList.add("processed");
			var productObj = JSON.parse(
				document.getElementById(e.dataset.objectId).textContent
			);
			var productOptionSelectors;
			var btn = e.parentNode.querySelector("form .ghost-button");
			var form_btn = e.parentNode.querySelector("form button");
			if (productObj.variants.length > 1) {
				var close_btn = e.parentNode.querySelector("span.close");
				btn.addEventListener("click", function (evt) {
					if (window.getComputedStyle(e, null).display == "none") {
						e.style.display = "block";
						form_btn.dataset.ova
						? form_btn.dataset.ova == "pre_order"
							? form_btn.innerText = window.languages.preOrder
							: form_btn.innerText = window.languages.productFormAddToCart
						: 0;
						btn.style.display = "none";
					}
				});
				form_btn.addEventListener("click", function (evt) {
					evt.preventDefault()
					func.atcSetText(
						hoculus.settings.atc_text_loader_time * 1000,
						form_btn,
						productObj
					);
					func.shopifyPostCart(form_btn.parentElement.parentElement);
					
				});
				close_btn.addEventListener("click", function () {
					e.style.display = "none";
					btn.style.display = "block";
					form_btn.innerText = theme.strings.buttonDefaultOptions;
				});
				productOptionSelectors = new Shopify.OptionSelectors2(e, {
					product: productObj,
					onVariantSelected: func.callback,
					enableHistoryState: false,
				});
			} else {
				btn.addEventListener("click", function (evt) {
					evt.preventDefault()
					btn.style.display = "none";
					func.atcSetText(
						hoculus.settings.atc_text_loader_time * 1000,
						form_btn,
						productObj
					);
					
					let nextId = e.nextElementSibling.getAttribute("id")
					func.shopifyPostCart(form = nextId.includes("script") ? e.nextElementSibling.nextElementSibling : e.nextElementSibling) 
					btn.style.display = "block";
				});
			}
		});
	};
	this.callback = (variant, container) => {
		if (container.nextElementSibling.querySelector('input[name="id"]')) (container.nextElementSibling.querySelector('input[name="id"]').value = variant.id);
	};

	this.atcSetText = function (time, form_btn, productObj) {
		if(hoculus.components?.loader) {
			form_btn.innerHTML = hoculus.components.loader;
		}
		setTimeout(() => {
			form_btn.innerText = theme.strings.addedToCart;
			setTimeout(() => {
				if (
					productObj.variants.length > 1 &&
					window.getComputedStyle(form_btn.parentElement.parentElement)
						.display != "none"
				) {
					form_btn.dataset.ova
						? form_btn.dataset.ova == "pre_order"
							? form_btn.innerText = window.languages.preOrder
							: form_btn.innerText = window.languages.productFormAddToCart
						: 0;
				} else if (productObj.variants.length > 1) {
					form_btn.innerText = theme.strings.buttonDefaultOptions;
				} else {
					form_btn.dataset.ova
						? form_btn.dataset.ova == "pre_order"
							? form_btn.innerText = window.languages.preOrder
							: form_btn.innerText = window.languages.productFormAddToCart
						: 0;
				}
			}, time);
		}, 500);
	};
	this.waitOptionSelection = (selects) => {
		let timeout = 200;
		if (typeof Shopify.OptionSelectors2 == "function") {
			func.loadSelects(selects);
		} else if (timeout >= 0) {
			setTimeout(function () {
				func.waitOptionSelection(selects);
				timeout = timeout - 1;
			}, 200);
		}
	};
	var selects = document.querySelectorAll(
		".hoculus-custom-select:not(.bundle-select):not(.processed)"
	);
	if (selects.length > 0) {
		func.waitOptionSelection(selects);
	}
};
var activate = Flickity.prototype.activate;
Flickity.prototype.activate = function() {
	if ( this.isActive ) {
		return;
	}
	activate.apply( this, arguments );
	if(this.options["hoculus"]) {
		this.options["hoculus"]["ready"]()
	}
};
hoculus.selectBundle = function () {
	var func = this;

	this.blockBtn = (el) => {
		el.diabled = true;
		el.style.minWidth = el.offsetWidth + "px";
		el.style.minHeight = el.offsetHeight + "px";
		let btnTxt = el.querySelector("span.btn-txt");
		btnTxt.style.display = "none";
		var loader = document.createElement("div");
		loader.innerHTML = hoculus.components.loader;
		btnTxt.parentElement.insertBefore(loader.firstChild, btnTxt);
	};
	this.unblockBtn = (el) => {
		el.diabled = false;
		let btnTxt = el.querySelector("span.btn-txt");
		btnTxt.style.display = "block";
		btnTxt.previousSibling.remove();
		el.style.minWidth = "unset";
		el.style.minHeight = "unset";
	};
	this.callback = function (variant, container) {
		let section = container.closest(".hoculus.custom-bundle");
		let variantsData = {};
		let preOrderData = {};
		let total = 0;
		section.querySelectorAll(".js-product-variant-id-input").forEach((e,index) => {
			let productObj = JSON.parse(
				document.getElementById(e.parentElement.dataset.objectId).textContent
			);
			let variantObjId = e.parentElement.dataset.objectId.replace("ProductObj","VariantsObj");
			let variantsObj = JSON.parse(
				document.getElementById(variantObjId).textContent
			);
			
			productObj.variants.forEach((j) => {
				if (j.id == e.value) {
					total += j.price;
					variantsData[e.value] = j.price;
				}
			});
			for (const [key, value] of Object.entries(variantsObj)) {
				if(key == e.value) {
					preOrderData[e.value] = false;
					if(value.inventory_quantity > 0) {
						preOrderData[e.value] = true
					} else if(value.inventory_quantity <= 0 && value.inventory_policy == "continue") {
						preOrderData[e.value] = value.pre_order_date
					}
				}
			  }
		});
		let atcBtn = section.querySelector("button[data-hoculus-bundle-variants]");
		let amount = total / 100;
		let discounted = 0;
		switch (atcBtn.dataset.hoculusBundleDiscountType) {
			case "fixed":
				discounted =
					amount - parseFloat(atcBtn.dataset.hoculusBundleDiscountAmount);
				break;
			case "percentage":
				discounted =
					(amount *
						(100 - parseFloat(atcBtn.dataset.hoculusBundleDiscountAmount))) /
					100;
				break;
		}
		section.querySelector(".before .price-before").innerText = "€" + amount;
		section.querySelector(".total .price").innerText =
			"€" + discounted.toFixed(2);
		atcBtn.dataset.hoculusBundleVariants = JSON.stringify(variantsData);
		atcBtn.dataset.hoculusVariantsData = JSON.stringify(preOrderData);
		
	};
	this.loadSelects = (selects) => {
		selects.forEach(function (e, i) {
			e.classList.add("processed");
			var productObj = JSON.parse(
				document.getElementById(e.dataset.objectId).textContent
			);
			if (productObj.variants.length > 1) {
				productOptionSelectors = new Shopify.OptionSelectors2(e, {
					product: productObj,
					onVariantSelected: func.callback,
					enableHistoryState: false,
				});
			}
		});
		document
			.querySelectorAll("button[data-hoculus-bundle-variants]")
			.forEach((e) => {
				e.addEventListener("click", function (evt) {
					let clickBtn = this;
					func.blockBtn(clickBtn);
					let items = [];
					let productObj = JSON.parse(clickBtn.dataset.hoculusBundleVariants);
					let variants = Object.keys(productObj);
					let preOrderCheck = JSON.parse(clickBtn.dataset.hoculusVariantsData)		
					variants.forEach((e) => {
						let variant = {
							id: e,
							quantity: 1,
						};
						if(typeof preOrderCheck[e] != 'boolean') {
							variant['properties'] = {};
							variant['properties']['Note'] = hoculus.translations.pre_order_label + preOrderCheck[e];
						}

						items.push(variant);
					});
					let discount = clickBtn.dataset.hoculusBundleDiscount;

					hoculus.utils
						.addToCart(items)
						.then((resp) => {
							hoculus.utils.addDiscount(discount);
						})
						.then(function () {
							hoculus.utils.openCart();
							func.unblockBtn(clickBtn);
						})
						.catch((error) => {
							func.unblockBtn(clickBtn);

							console.log(error)
							if (error.responseJSON.status == 422) {
								clickBtn.querySelector("span.btn-txt").innerText =
									hoculus.translations.oneOrMoreOut;
							} else {
								clickBtn.querySelector("span.btn-txt").innerText =
									hoculus.translations.errorLater;
							}
						});
				});
			});
	};
	this.waitOptionSelection = (selects) => {
		let timeout = 200;
		if (typeof Shopify.OptionSelectors2 == "function") {
			func.loadSelects(selects);
		} else if (timeout >= 0) {
			setTimeout(function () {
				func.waitOptionSelection(selects);
				timeout = timeout - 1;
			}, 50);
		}
	};

	var selects = document.querySelectorAll(
		".hoculus-custom-select.bundle-select:not(.processed)"
	);
	if (selects.length > 0) {
		func.waitOptionSelection(selects);
	}
};

hoculus.flickityCart = (evts) => {
	var func = this;
	this.defineNewFlick = function(slider,dataset) {
		let options = JSON.parse(slider.dataset[dataset])
		options.hoculus = {}
		options["hoculus"]["ready"] = function() {
			hoculus.selectCustomPcard()
		}
		let ns = new Flickity(slider, options)
	}
	evts.forEach(evt => {
		document.addEventListener(evt, function() {
			var original_flick = document.querySelector("[data-hoculus-original-flickity-config]");
			
			if(original_flick) {
				let new_slider = document.createElement("div")
				let dmain = document.querySelector(".Cart.Drawer__Content .Drawer__Main")

				new_slider.innerHTML = document.querySelector("[data-hoculus-original-flickity-config]").outerHTML
				if(!dmain.querySelector("[data-hoculus-original-flickity-config]")) {
					new_slider.firstElementChild.querySelectorAll(".hoculus-abs-container .hoculus-custom-select.processed").forEach(e=> {
						e.classList.remove("processed")
					})
					
					dmain.append(new_slider);
					if(new_slider.firstElementChild.querySelectorAll(".hoculus-abs-container .hoculus-custom-select.processed").length == 0) {
						hoculus.selectCustomPcard()
					}
				}
				func.defineNewFlick(new_slider.firstElementChild,"hoculusOriginalFlickityConfig");
			}
			let flicks = document.querySelectorAll(".hoculus__flickity[data-hoculus-flickity-config]")
			flicks.forEach(fs=> {
				func.defineNewFlick(fs,"hoculusFlickityConfig");
			})
		})
	})
}
hoculus.stickyBuy = () => {
	const selectors = {
		sticky: ".hoculus-atc-sticky",
		targetAtc: ".Product__Wrapper [data-action=add-to-cart]"
	}
	var sticky = document.querySelector(selectors.sticky);
	var target = document.querySelector(selectors.targetAtc);

	if(!target || !sticky) return;
	let buttonObserver = new IntersectionObserver(showButton);
	buttonObserver.observe(target)

	function showButton(entries, observer) {
		entries.forEach(entry => {
		  if (entry.isIntersecting) {
			sticky.style.display = "none";
			document.querySelector("#dummy-chat-button-iframe").style.bottom = '24px';
		  } else {
			sticky.style.display = "flex";
			document.querySelector("#dummy-chat-button-iframe").style.bottom = '100px';
		  }
		});
	}
}

hoculus.flickityCart(["hoculus:cart:drawer:refresh"])

hoculus.utils.domready(hoculus.utils.onLoad);
